<template>
  <div class="p-3">
    <h1 class="text-center my-4 font-bold">{{$t('login.recover-password')}}</h1>
    <p>{{$t('login.recover-password-text')}}</p>

    <div class="flex flex-col items-stretch">
      <input type="email" class="inp p-2 my-2" autocomplete="email" :placeholder="$t('form.email.placeholder')" v-model="email">
      <div v-if="error" class="text-red-600 my-2">
        ⚠ {{ $t(`error.${error}`) }}
      </div>  
      <button class="btn btn-1" @click="recoverPassword">{{$t('send')}}</button>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      email: '',
      error: false
    }
  },

  methods: {
    async recoverPassword() {
      this.error = false
      try {
        await this.$store.dispatch('recoverPassword', this.email)
        this.$router.replace({name: 'Login'})
      } catch(e) {
        this.error = e.code
      }
    },
    
  }
}
</script>

<style>

</style>